import i18n from 'i18next';

/**
 * Parses a Wakam error string to extract a human-readable message.
 *
 * Wakam errors can come in several forms:
 * - A plain string with a JSON object at the end containing a `message` field
 * - A plain error string (e.g. failedReason from QuoteFailedErrorDto)
 */
export function parseWakamError(errorString: string | undefined | null): string | null {
  if (!errorString) return null;

  const quoteFailedReasonKey = `errors.quoteFailedReason.${errorString}`;
  if (i18n.exists(quoteFailedReasonKey)) return i18n.t(quoteFailedReasonKey);

  const jsonMatch = errorString.match(/\{.*\}$/);
  if (jsonMatch) {
    try {
      const parsed = JSON.parse(jsonMatch[0]);
      if (typeof parsed.message === 'string') return parsed.message;
    } catch {
      // Not valid JSON, fall through
    }
  }

  return errorString;
}
